import React from "react";
import "../blocks/Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <p className="footer__copyright">© 2021 Around The U.S.</p>
    </footer>
  );
}

export default Footer;
